if (!customElements.get('compatibility-badge')) {
  const CHANGE_EVENT = 'compatibility-finder:change';
  const savedEntries = new Map();

  function readEntries(key) {
    if (savedEntries.has(key)) return savedEntries.get(key);

    let entries = [];
    try {
      const parsed = JSON.parse(window.localStorage.getItem(key) || '[]');
      if (Array.isArray(parsed)) {
        entries = parsed.filter(entry => entry && Array.isArray(entry.filters) && entry.filters.length);
      }
    } catch (error) {
      // Storage may be unavailable (private browsing).
    }

    savedEntries.set(key, entries);
    return entries;
  }

  /* one listener for the whole page rather than one per badge, so a collection
     of cards costs nothing extra and badges added later are picked up too */
  function refreshAll(key) {
    if (key) {
      savedEntries.delete(key);
    } else {
      savedEntries.clear();
    }

    document.querySelectorAll('compatibility-badge').forEach(badge => badge.render());
  }

  document.addEventListener(CHANGE_EVENT, event => refreshAll(event.detail?.storageKey));
  window.addEventListener('storage', event => {
    if (event.key === null || savedEntries.has(event.key)) refreshAll(event.key);
  });

  class CompatibilityBadge extends HTMLElement {
    connectedCallback() {
      if (window.sectionInstances.has(this)) return;
      window.sectionInstances.set(this, true);

      this.storageKey = this.dataset.storageKey || 'theme-compatibility-finder';

      try {
        this.fitment = JSON.parse(this.dataset.fitment || 'null');
      } catch (error) {
        this.fitment = null;
      }

      this.messages = this.querySelectorAll('.js-compat-confirmed, .js-compat-uncertain, .js-compat-incompatible');

      /* keep the untouched text so the names can be swapped again when the
         customer renames, adds or removes a saved product */
      this.nameSlots = [];
      this.messages.forEach(message => {
        const walker = document.createTreeWalker(message, NodeFilter.SHOW_TEXT);

        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (node.nodeValue.includes('[name]')) {
            this.nameSlots.push({ node, template: node.nodeValue });
          }
        }
      });

      this.render();
    }

    // DX integration: exact tuple rules live in the independently versioned asset.
    vehicle(entry) {
      return window.DXFitment?.vehicle(entry) || null;
    }

    matchState(vehicle) {
      return window.DXFitment?.matchState(this.fitment, vehicle) || 'unknown';
    }

    render() {
      const entries = readEntries(this.storageKey);
      const vehicles = entries.map(entry => this.vehicle(entry));
      const matched = vehicles.filter(vehicle => this.matchState(vehicle) === 'match');
      const names = [...new Set(matched.map(vehicle => vehicle.name))].join(', ');
      const preview = this.dataset.preview;
      if (preview === 'uncertain') return this.show('.js-compat-uncertain');
      if (preview && preview !== 'none') return this.show('.js-compat-confirmed', names);
      if (!entries.length) return this.show();
      if (matched.length) return this.show('.js-compat-confirmed', names);
      if (vehicles.every(vehicle => this.matchState(vehicle) === 'no-match')) {
        return this.show('.js-compat-incompatible', [...new Set(vehicles.map(vehicle => vehicle.name))].join(', '));
      }
      this.show('.js-compat-uncertain');
    }

    show(selector, names) {
      const message = selector ? this.querySelector(selector) : null;

      this.dataset.fitmentState = selector === '.js-compat-confirmed' ? 'match' : selector === '.js-compat-incompatible' ? 'no-match' : selector ? 'unknown' : 'no-vehicle';
      this.fillNames(names);
      this.messages.forEach(other => { other.hidden = other !== message; });
      this.hidden = message === null;
    }

    fillNames(names) {
      this.nameSlots.forEach(slot => {
        slot.node.nodeValue = slot.template.replace('[name]', names || '[name]');
      });
    }
  }

  customElements.define('compatibility-badge', CompatibilityBadge);
}

